
import Vue from 'vue'
import ApiHttpService from '@/core/http/api.http.service'

export default Vue.extend({
    name: 'RecuperarContaComponent',
    data() {
        return {
            loading: false,
            email: ''
        }
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        },
        temEmail():boolean {
            return this.email !== '';
        }
    },
    methods: {
        recuperarConta() {
            this.loading = true;
            ApiHttpService.post<any>(`/usuario/recuperacao-senha?email=${this.email}`, {}).then(result => {
                const message = result.messages[0].text

                if (result.success) {
                    this.$toast.info(message || `E-mail de recuperação de senha enviado com sucesso!`);
                    this.email = '';
                } else {
                    this.$toast.warning(message || `Por favor revise os campos para prosseguir.`)
                }
            }).finally(() => {
                this.loading = false;
            })
        },
        voltarLogin() {
            this.$emit(`step`, 1);
        }
    }
})
